import React from "react";
import { IAppIco } from "../types";

export const MenuTopEdgeIco: React.FC<IAppIco> = ({ fill, height, width }) => {
    return (
        <svg className="menu-edge" width={width || "10"} height={height || "10"} viewBox="10 10 10 10" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 0C4.47715 0 0 4.47715 0 10V0H10ZM20 10C20 4.47715 15.5228 0 10 0H20V10ZM10 20C4.47715 20 0 15.5228 0 10V20H10ZM10 20C15.5228 20 20 15.5228 20 10V20H10Z"
                fill={fill || "#ffffff"}
            />
        </svg>
    );
};
